import script from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./SlideToolbar.vue?vue&type=style&index=0&id=dcc0171c&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc0171c"]])

export default __exports__